<template>
    <div class="d-flex justify-content-center pb-3 ">
        <img src="@/assets/icons/cards.svg" class="d-inline-block mx-auto" alt="Bandeiras de cartões de crédito">
    </div>
</template>
